import React from 'react'

const PrimaryFormColTwo = ({children}) => {
  return (
    <div className="primary-form-col-2">
        {children}
    </div>
  )
}

export default PrimaryFormColTwo